import { DataItemType, FormControlType } from "@cloudpivot/form/schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from './components/WorkReport.vue';
import mobile from './components/mobile.vue';
export const info = {
    title: "工作汇报",
    type: "work-report",
    icon: "h-icon-all-a-Drop-downsingle-o",
    dataItemType: DataItemType.LongText,
    formControllerType: FormControlType.WorkReport,
    group: "高级控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc,
        mobile
    },
};
